var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "semantic-page" }, [
    _c("div", { staticClass: "semantic-head" }, [
      _c("div", { staticClass: "semantic-head-inner" }, [
        _c("h1", [_vm._v("语义检索")]),
        _vm._v(" "),
        _c("p", [_vm._v("用自然语言描述你想学习的内容")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "semantic-form" },
          [
            _c("el-input", {
              attrs: {
                clearable: "",
                autofocus: "",
                placeholder:
                  "例如：我想找适合零基础学习新能源汽车电池维修的课程",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.submitSearch($event)
                },
              },
              model: {
                value: _vm.query,
                callback: function ($$v) {
                  _vm.query = $$v
                },
                expression: "query",
              },
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  icon: "el-icon-search",
                  loading: _vm.loading,
                },
                on: { click: _vm.submitSearch },
              },
              [_vm._v("\n          搜索\n        ")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "semantic-content" },
      [
        _vm.query && _vm.searched
          ? _c("div", { staticClass: "semantic-result-head" }, [
              _c("span", [
                _vm._v(
                  "为“" +
                    _vm._s(_vm.query) +
                    "”找到 " +
                    _vm._s(_vm.total) +
                    " 条资源"
                ),
              ]),
              _vm._v(" "),
              _vm.fallback
                ? _c("span", { staticClass: "semantic-tip" }, [
                    _vm._v(_vm._s(_vm.message)),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "semantic-list",
          },
          [
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                {
                  key: item.resourceType + ":" + item.id,
                  staticClass: "semantic-item",
                  on: {
                    click: function ($event) {
                      return _vm.openItem(item)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "semantic-cover",
                    attrs: { src: item.courseImage || _vm.notImg, alt: "" },
                    on: { error: _vm.handleImageError },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "semantic-item-main" }, [
                    _c("div", { staticClass: "semantic-item-title" }, [
                      _vm._v(_vm._s(item.courseName || "未命名资源")),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "semantic-tags" }, [
                      _c(
                        "span",
                        { staticClass: "semantic-tag semantic-tag-blue" },
                        [_vm._v(_vm._s(item.resourceTypeName))]
                      ),
                      _vm._v(" "),
                      item.fkCourseMajor
                        ? _c("span", { staticClass: "semantic-tag" }, [
                            _vm._v(_vm._s(item.fkCourseMajor)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.schoolLevel
                        ? _c("span", { staticClass: "semantic-tag" }, [
                            _vm._v(_vm._s(item.schoolLevel)),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "semantic-meta" }, [
                      item.fkCourseEmceeSchool
                        ? _c("span", [_vm._v(_vm._s(item.fkCourseEmceeSchool))])
                        : _vm._e(),
                      _vm._v(" "),
                      item.courseEmceeName
                        ? _c("span", [_vm._v(_vm._s(item.courseEmceeName))])
                        : _vm._e(),
                      _vm._v(" "),
                      item.origin
                        ? _c("span", [_vm._v(_vm._s(item.origin))])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "semantic-description" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.courseInfo || "暂无简介") +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    item.reason
                      ? _c("div", { staticClass: "semantic-reason" }, [
                          _vm._v(
                            "\n            匹配理由：" +
                              _vm._s(item.reason) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-arrow-right semantic-arrow",
                  }),
                ]
              )
            }),
            _vm._v(" "),
            _vm.searched && !_vm.loading && _vm.items.length === 0
              ? _c("div", { staticClass: "semantic-empty" }, [
                  _c("i", { staticClass: "el-icon-search" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂未找到匹配资源")]),
                ])
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm.total > _vm.pageSize
          ? _c("el-pagination", {
              attrs: {
                background: "",
                layout: "prev, pager, next",
                "current-page": _vm.pageNum,
                "page-size": _vm.pageSize,
                total: _vm.total,
              },
              on: { "current-change": _vm.changePage },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }